import Vue from "vue";
import VueRouter from "vue-router";
import ViAdmissionHome from "../views/ViAdmissionHome.vue";

import ViHome from "../views/ViHome.vue";
import NotFoundHandler from "../views/ViErrorHandler.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: ViHome,
    children: [
      {
          path: 'admission',
          component: ViAdmissionHome,
          children: [
            {
              path: "/parent/home",
              name: "parentHome",
              component: () => import(/* webpackChunkName: "parentHome" */ "../components/Parent/ViParentHome"),
              meta: {
                history: 'Parent',
              },
             // beforeEnter: AuthGuard,
            },
            {
              path: "/parent/search/home",
              name: "ViHomeHeroSearch",
              component: () => import(/* webpackChunkName: "ViHomeHeroSearch" */ "../components/Parent/ViHomeHeroSearch"),
              meta: {
                history: 'Parent',
              },
            //  beforeEnter: AuthGuard,
            },
            {
              path: "/parent/onlinetc",
              name: "onlineTc",
              component: () => import(/* webpackChunkName: "onlineTc" */ "../components/Parent/ViParentOnlineTC"),
              meta: {
                history: 'Parent',
              },
             // beforeEnter: AuthGuard,
            },
            
            {
              path: "/parent/student/home/:id",
              name: "ViStudentHome",
              component: () => import(/* webpackChunkName: "ViStudentHome" */ "../components/Parent/ViStudentHome"),
              meta: {
                history: 'Parent',
              },
             // beforeEnter: AuthGuard,
            },
            {
              path: "/parent/student/portal/view/details/:id",
              name: "studentSummary",
              component: () => import(/* webpackChunkName: "studentParentPortalSummary" */ "../components/Parent/ViStudentSummary"),
              meta: {
                history: 'Parent',
              },
             // beforeEnter: AuthGuard,
            },
            {
              path: "/parent/ratingAndReview/school/:id",
              name: "ViParentReview",
              component: () => import(/* webpackChunkName: "ViParentReview" */ "../components/Parent/ViParentReview"),
              meta: {
                history: 'Parent',
              },
             // beforeEnter: AuthGuard,
            },
            
            {
              path: "/parent/student/paymentHistory/:id",
              name: "paymentHistory",
              component: () => import(/* webpackChunkName: "ViPaymentHistory" */ "../components/Parent/ViPaymentHistory"),
              meta: {
                history: 'Parent',
              },
             // beforeEnter: AuthGuard,
            },
           
            {
              path: "/parent/student/freePortal/view/admission/details/:id",
              name: "studentSummary",
              component: () => import(/* webpackChunkName: "studentParentPortalSummary" */ "../components/Parent/ViStudentFreeSchoolSummary"),
              meta: {
                history: 'Parent',
              },
             // beforeEnter: AuthGuard,
            },
            {
              path: "/parent/admission",
              name: "admission",
              component: () => import(/* webpackChunkName: "admission" */ "../components/Parent/ViParentAdmission"),
              meta: {
                history: 'Parent',
              },
             // beforeEnter: AuthGuard,
            },
            
            {
              path: "/parent/search-school",
              name: "parent-search",
              component: () => import(/* webpackChunkName: "parent-search" */ "../components/Parent/ViParentSchools"),
              meta: {
                history: 'Parent',
              },
             // beforeEnter: AuthGuard,
            },
           
            
          ]
      },
     
      {
        path: "/register/jobseeker",
        name: "register-jobseeker",
        component: () =>
          import(
            /* webpackChunkName: "jobseeker" */ "../components/Profile/ViRegisterJobSeeker.vue"
          ),
      },
      {
        path: "/register/parent",
        name: "register-parent",
        component: () =>
          import(
            /* webpackChunkName: "parent" */ "../components/Profile/ViRegisterParentSelf.vue"
          ),
      },
      {
        path: "/register/school",
        name: "register-school",
        component: () =>
          import(
            /* webpackChunkName: "school" */ "../components/Profile/ViRegisterSchoolIndividual.vue"
          ),
      },
      
      {
        path: "/search-schools",
        name: "schools",
        component: () =>
          import(
            /* webpackChunkName: "school-list" */ "../components/School/ViSchools.vue"
          ),
        props: true,
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(
        /* webpackChunkName: "login" */ "../components/Profile/ViLogin.vue"
      ),
  },
  
  {
    path: "/search-school/overview",
    name: "register-school",
    component: () =>
      import(
        /* webpackChunkName: "search-scdddddhool" */ "../components/Profile/CommonSchoolSearch.vue"
      ),
  },
  {
    path: "/search-schools",
    name: "schools",
    component: () =>
      import(
        /* webpackChunkName: "school-list" */ "../components/School/ViSchools.vue"
      ),
    props: true,
  },
  
  {
    path: "/forgotPassword",
    name: "forgotPassword",
    component: () =>
      import(
        /* webpackChunkName: "forgotPassword" */ "../components/Profile/ViForgotPassword.vue"
      ),
  },
  {
    path: "/change-password",
    name: "change-password",
    component: () =>
      import(
        /* webpackChunkName: "forgotPassword" */ "../components/Profile/ViResetPassword.vue"
      ),
  },
  {
    path: "/register/parent",
    name: "register-parent",
    component: () =>
      import(
        /* webpackChunkName: "parent" */ "../components/Profile/ViRegisterParentSelf.vue"
      ),
  },
  {
    path: "/register/school",
    name: "register-school",
    component: () =>
      import(
        /* webpackChunkName: "school" */ "../components/Profile/ViRegisterSchoolIndividual.vue"
      ),
  },
  {
    path: "/invitaion-accept",
    name: "invitaion",
    component: () =>
      import(
        /* webpackChunkName: "ViAcceptInvation" */ "../components/Profile/ViAcceptInvation.vue"
      ),
  },
  
  {
    path: "/pricingView",
    name: "pricing",
    component: () =>
      import(/* webpackChunkName: "pricing" */ "../views/ViPricing.vue"),
  },
  {
    path: "/admin-panel",
    name: "admin",
    component: () =>
      import(
        /* webpackChunkName: "pricing" */ "../components/Admin/ViAdmin.vue"
      ),
  },
  {
    path: "/grand-login/validate",
    name: "grandLogin",
    component: () =>
      import(
        /* webpackChunkName: "pricing" */ "../components/Admin/ViGrandLogin.vue"
      ),
  },
  {
    path: "/paymentConfirmation",
    name: "payment",
    component: () =>
      import(
        /* webpackChunkName: "payment" */ "../views/ViPaymentCompletd.vue"
      ),
  },
  {
    path: "/subscribe/enrollSchool",
    name: "enrollSchool",
    component: () =>
      import(
        /* webpackChunkName: "enrollSchool" */ "../views/ViEnrollPlan.vue"
      ),
  },
  { path: "*", component: NotFoundHandler },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {

  const IsItABackButton = window.popStateDetected;
  window.popStateDetected = false;
  if (IsItABackButton && from.meta.someLogica) {
    next(false);
    return "";
  }
  next();
});

export default router;
